const findErrorUTL = (err, key) => err.find((item) => item.includes(key));
export default findErrorUTL;
